

export class Admin_Dashboard_Monthly_Late_Early implements IAdmin_Dashboard_Monthly_Late_Early {
    eventDate!: Date;
    lateCount!: number | undefined;
    earlyCount!: number | undefined;
    missingThumbCount!: number | undefined;

    constructor(data?: IAdmin_Dashboard_Monthly_Late_Early) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.lateCount = _data["lateCount"];
            this.earlyCount = _data["earlyCount"];
            this.missingThumbCount = _data["missingThumbCount"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Monthly_Late_Early {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Monthly_Late_Early();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["lateCount"] = this.lateCount;
        data["earlyCount"] = this.earlyCount;
        data["missingThumbCount"] = this.missingThumbCount;
        return data; 
    }
}

export interface IAdmin_Dashboard_Monthly_Late_Early {
    eventDate: Date;
    lateCount: number | undefined;
    earlyCount: number | undefined;
    missingThumbCount: number | undefined;
}

